import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export const downloadPDF = async (id, document_name) => {
  const element = document.getElementById(id);

  const canvas = await html2canvas(element, {
    scale: 3,
    useCORS: true,
    allowTaint: true,
  });

  const imgData = canvas.toDataURL("image/jpeg", 1.0);

  // A4 size in mm
  const pdf = new jsPDF("p", "mm", "a4");
  const pdfWidth = 210;
  const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  let heightLeft = pdfHeight;
  let position = 0;

  // First page
  pdf.addImage(imgData, "JPEG", 0, position, pdfWidth, pdfHeight);
  heightLeft -= 297;

  // Multi-page support
  while (heightLeft > 0) {
    position = heightLeft - pdfHeight;
    pdf.addPage();
    pdf.addImage(imgData, "JPEG", 0, position, pdfWidth, pdfHeight);
    heightLeft -= 297;
  }

  pdf.save(document_name+".pdf");
};
